Namespace 'Common.Dashboard'

class Common.Dashboard.PreviewChartOptions
  chartOptions: (chartType, stacking = null) ->
    chartOptions =
      chart:
        plotBackgroundColor: null
        plotBorderWidth: null
        plotShadow: false
      title: null
      legend:
        enabled: false
      plotOptions:
        pie:
          dataLabels:
            enabled: false
        bar:
          colorByPoint: true
        column:
          colorByPoint: true
      xAxis:
        labels:
          enabled: false
      yAxis:
        title:
          text: null
        labels:
          enabled: false
      tooltip:
        enabled: false
      exporting:
        enabled: false

    customOptions =
      bar:
        series: [{type: 'bar', data: [45, 26, 12, 8, 6, 1]}]
      column:
        series: [{type: 'column', data: [45, 26, 12, 8, 6, 1]}]
      pie:
        series: [{type: 'pie', data: [45, 26, 12, 8, 6, 1]}]
      spline:
        series: [
          {data: [7, 8, 9, 14, 18, 21, 25, 26, 23, 18, 13, 9]},
          {data: [3, 4, 5, 8, 11, 15, 17, 16, 14, 10, 6, 4]}
        ]
      areaspline:
        series: [
          {type: 'areaspline', data: [3, 4, 3, 5, 4, 10, 12]},
          {type: 'areaspline', data: [1, 3, 4, 3, 3, 5, 4]}
        ]
      area:
        series: [
          {type: 'area', data: [502, 635, 809, 947, 1402, 3634, 5268]},
          {type: 'area', data: [106, 107, 111, 133, 221, 767, 1766]},
          {type: 'area', data: [163, 203, 276, 408, 547, 729, 628]},
          {type: 'area', data: [18, 31, 54, 156, 339, 818, 1201]}
        ]
        plotOptions: {area: {stacking: stacking}}
      stacked:
        series: [
          {type: 'column', data: [5, 3, 4, 7, 2]},
          {type: 'column', data: [2, 2, 3, 2, 1]},
          {type: 'column', data: [3, 4, 4, 2, 5]}
        ]
        plotOptions: {column: {stacking: stacking, colorByPoint: false}}
      heatmap:
        series: [{
          borderWidth: 0,
          data: [
            [1, 0, 92], [1, 1, 58], [1, 2, 78], [1, 3, 117], [1, 4, 48], [2, 0, 35], [2, 1, 15], [2, 2, 123],
            [2, 3, 64], [2, 4, 52], [3, 0, 72], [3, 1, 132], [3, 2, 114], [3, 3, 19], [3, 4, 16], [4, 0, 38],
            [4, 1, 5], [4, 2, 8], [4, 3, 117], [4, 4, 115], [5, 0, 88], [5, 1, 32], [5, 2, 12], [5, 3, 6],
            [5, 4, 120], [6, 0, 13], [6, 1, 44], [6, 2, 88], [6, 3, 98], [6, 4, 96], [7, 0, 31], [7, 1, 1],
            [7, 2, 82], [7, 3, 32], [7, 4, 30], [8, 0, 85], [8, 1, 97], [8, 2, 123], [8, 3, 64], [8, 4, 84],
            [9, 0, 47], [9, 1, 114], [9, 2, 31], [9, 3, 48], [9, 4, 91]
          ],
          type: 'heatmap'
          dataLabels: {
            enabled: false,
          }
        }]
        colorAxis: {
          min: 0,
          minColor: '#FFFFFF',
          maxColor: '#FF9800'
        },
        legend: {
          enabled: true,
          align: 'right',
          layout: 'vertical',
          margin: 0,
          y: 0,
          symbolHeight: 190
        }

    $.extend(true, chartOptions, customOptions[chartType])
